module.exports = __webpack_public_path__ + "4645a47c25fd8d7b6c8292b147ffe927.png";